import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { ModalState } from '../../_stores/modal/_state/modal.state';
import { ModalCloseAction } from '../../_stores/modal/_actions/modal.actions';
import { LoadControlSchools } from '../../_stores/control/_actions/control.actions';
import { DeleteSchool } from '../../_stores/schools/_actions/school.actions';

@Component({
  selector: 'ui-control-schools-delete',
  templateUrl: './ui-control-schools-delete.component.html',
  styleUrls: ['./ui-control-schools-delete.component.scss'],
})
export class UiControlSchoolsDeleteComponent implements OnInit {
  interface: any = {
    loading: false,
    _id: null,
  };

  constructor(private store: Store, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initDataID();
  }

  initDataID() {
    this.store.select(ModalState.selectOpenedID).subscribe((_openedID) => {
      this.interface._id = _openedID;
      this.cdr.detectChanges();
    });
  }

  actionConfirm(): void {
    this.interface.loading = true;
    this.store.dispatch(new DeleteSchool({ schoolID: this.interface._id })).subscribe({
      next: () => {
        this.store.dispatch(new LoadControlSchools('', 1, '', '')).subscribe({
          next: () => {
            this.interface.loading = false;
            this.actionClose();
            this.cdr.detectChanges();
          },
        });
        this.cdr.detectChanges();
      },
    });
  }

  actionClose() {
    this.store.dispatch(new ModalCloseAction());
  }
}
